// extracted by mini-css-extract-plugin
module.exports = {"row":"NewCategory_row__5DOOb","col":"NewCategory_col__1MDjT","card":"NewCategory_card__1NmxT"};